import React, { useState, useEffect } from "react";

import * as APIModels from "../../../../models";
import { AttorneyService } from "../../../../services/ClientService";
import MaterialTable, {
    Column,
    EditComponentProps,
} from "@material-table/core";
import { useCallback } from "react";

export default function CaseNumberRegex({
    attorney,
}: {
    attorney: APIModels.Attorney;
}) {
    const never = "never" as const;
    const [caseNumberRegexes, setCaseNumberRegexes] = useState(
        [] as APIModels.CaseNumberRegex[]
    );

    const refreshData = () => {
        if (attorney.id != "") {
            AttorneyService.caseNumberRegex({
                attorneyId: attorney.id ?? "",
            }).then(
                (resp) => {
                    if (resp.successful === true) {
                        setCaseNumberRegexes(
                            resp.data as APIModels.CaseNumberRegex[]
                        );
                    } else {
                        console.log("error");
                    }
                },
                (error) => {
                    console.log(error);
                }
            );
        }
    };

    useEffect(() => {
        console.log("Regex ", attorney.id);
        AttorneyService.caseNumberRegex({ attorneyId: attorney.id ?? "" }).then(
            (resp) => {
                if (resp.successful === true) {
                    setCaseNumberRegexes(
                        resp.data as APIModels.CaseNumberRegex[]
                    );
                    console.log("Regex Success " + JSON.stringify(resp.data));
                } else {
                    console.log("error");
                }
            },
            (error) => {
                console.log(error);
            }
        );
    }, [attorney]);

    return (
        <div className="card text-center">
            <div className="card-body">
                <div style={{ maxWidth: "100%", zIndex: -1 }}>
                    <MaterialTable
                        columns={[
                            {
                                title: "ID",
                                field: "id",
                                editable: never,
                            },
                            {
                                title: "County",
                                field: "county",
                            },
                            {
                                title: "Regex",
                                field: "regex",
                            },
                            {
                                title: "Active",
                                field: "active",
                                type: "boolean" as const,
                            },
                        ]}
                        data={caseNumberRegexes}
                        title="Case Number Regexes"
                        editable={{
                            onRowAdd: (newData) =>
                                new Promise((resolve, reject) => {
                                    AttorneyService.addCaseNumberRegex({
                                        body: {
                                            ...newData,
                                            attorneyID: attorney.id,
                                            active: true,
                                        },
                                    }).then(
                                        (resp) => {
                                            refreshData();
                                            resolve(null);
                                        },
                                        (error) => {
                                            console.log(error);
                                            resolve(null);
                                        }
                                    );
                                    resolve(null);
                                }),
                            onRowUpdate: (newData, oldData) =>
                                new Promise((resolve, reject) => {
                                    AttorneyService.updateCaseNumberRegex({
                                        id: oldData?.id ?? "",
                                        body: newData!,
                                    }).then(
                                        (resp) => {
                                            refreshData();
                                            resolve(null);
                                        },
                                        (error) => {
                                            console.log(error);
                                            resolve(null);
                                        }
                                    );
                                    resolve(null);
                                }),
                            onRowDelete: (oldData) =>
                                new Promise((resolve, reject) => {
                                    AttorneyService.deleteCaseNumberRegex({
                                        id: oldData.id ?? "",
                                    }).then(
                                        (resp) => {
                                            refreshData();
                                            resolve(null);
                                        },
                                        (error) => {
                                            console.log(error);
                                            resolve(null);
                                        }
                                    );
                                    resolve(null);
                                }),
                        }}
                    />
                </div>
            </div>
        </div>
    );
}
